import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Text } from '../../atoms';
const Term = (props) => (_jsx(Text.Body, { as: "dt", alpha: "high", ...props }));
const Details = (props) => (_jsx(Text.Body, { as: "dd", css: { display: 'flex', flexDirection: 'column', alignItems: 'flex-end', textAlign: 'end' }, ...props }));
const Description = (props) => (_jsx("div", { css: { display: 'flex', justifyContent: 'space-between' }, ...props }));
const DescriptionList = Object.assign((props) => _jsx("dl", { ...props, css: { '> * + *': { marginTop: '1.6rem' } } }), { Description, Term, Details });
export default DescriptionList;
